module.exports = __webpack_public_path__ + "img/asset-01.84164c19.svg";